import styled from "styled-components";

const LINE = "#d9d9d9";

const PaySlipSc = styled.div`
  padding: 24px 32px 48px;
  color: #1a1a1a;
  display: flex;
  flex-direction: column;
  align-items: center;

  .payslip-toolbar {
    display: flex;
    align-items: end;
    gap: 16px;
    margin-bottom: 20px;
    width: 820px;
    max-width: 100%;
  }

  label {
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: #ffffff;
    font-weight: 600;
  }

  input[type="month"] {
    border: 1px solid #cfcfcf;
    border-radius: 8px;
    padding: 9px 12px;
    color: #1c1c28;
    background: #ffffff;
  }

  button {
    border: 0;
    border-radius: 8px;
    padding: 10px 20px;
    background: #2d3592;
    color: #ffffff;
    cursor: pointer;
    font-weight: 600;
  }

  button:disabled {
    opacity: 0.7;
    cursor: default;
  }

  .slip {
    width: 820px;
    background: #ffffff;
    color: #222222;
    padding: 28px 32px 26px;
    box-sizing: border-box;
  }

  .slip-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 14px;
    border-bottom: 2px solid #222222;
  }

  .slip-head img {
    width: 148px;
    height: auto;
    display: block;
  }

  .slip-addr {
    margin-top: 12px;
    font-size: 12px;
    line-height: 1.45;
    color: #555555;
  }

  .slip-meta {
    text-align: right;
    padding-top: 4px;
  }

  .slip-title {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #222222;
  }

  .slip-month {
    margin-top: 4px;
    font-size: 13px;
    color: #555555;
  }

  .info-table,
  .pay-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    background: #ffffff;
  }

  .info-table {
    margin-top: 18px;
  }

  .pay-table {
    margin-top: 22px;
  }

  .col-field {
    width: 16%;
  }

  .col-val {
    width: 34%;
  }

  .col-item {
    width: 30%;
  }

  .col-amt {
    width: 20%;
  }

  .info-table td,
  .pay-table td {
    display: table-cell;
    border: 1px solid ${LINE};
    padding: 7px 8px;
    font-size: 12.5px;
    line-height: 1.3;
    color: #222222;
    background: #ffffff;
    text-align: left;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
  }

  .info-table td.field {
    color: #666666;
    font-weight: 400;
  }

  .info-table td.val {
    font-weight: 700;
    color: #1a1a1a;
  }

  .pay-table td.head {
    background: #f2f2f2;
    color: #333333;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }

  .pay-table td.amt,
  .pay-table td.head.amt {
    text-align: right;
  }

  .pay-table td.total {
    font-weight: 700;
    background: #f7f7f7;
  }

  .payable {
    margin-top: 16px;
    border: 1px solid ${LINE};
    background: #ffffff;
  }

  .payable-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 12px 14px;
    background: #f2f2f2;
    border-bottom: 1px solid ${LINE};
  }

  .payable-row span {
    color: #333333;
    font-weight: 700;
    font-size: 13px;
    white-space: nowrap;
  }

  .payable-row strong {
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 700;
    white-space: nowrap;
  }

  .payable-words {
    padding: 8px 14px;
    color: #555555;
    font-size: 13px;
    font-style: italic;
  }

  .slip-error {
    width: 100%;
    margin: 12px 0 0;
    color: #8a1f3d;
    font-size: 13px;
  }

  .slip-note {
    margin-top: 22px;
    padding-top: 12px;
    border-top: 1px solid ${LINE};
    text-align: center;
    color: #888888;
    font-size: 11px;
    line-height: 1.55;
  }
`;

export default PaySlipSc;
